import React from 'react';

/**
 * Thinking status icon component
 * Displays animated loading spinner to indicate thinking/processing state
 */
const ThinkingIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg 
    width="18" 
    height="18" 
    viewBox="0 0 18 18" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path 
      opacity="0.9" 
      d="M3.69922 14.3022L5.82172 12.1797" 
      stroke="currentColor" 
      strokeWidth="2" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path 
      opacity="0.8" 
      d="M1.5 9H4.5" 
      stroke="currentColor" 
      strokeWidth="2" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path 
      opacity="0.7" 
      d="M3.69922 3.69727L5.82172 5.81977" 
      stroke="currentColor" 
      strokeWidth="2" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path 
      opacity="0.6" 
      d="M9 1.5V4.5" 
      stroke="currentColor" 
      strokeWidth="2" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path 
      opacity="0.5" 
      d="M12.1797 5.81977L14.3022 3.69727" 
      stroke="currentColor" 
      strokeWidth="2" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path 
      opacity="0.4" 
      d="M13.5 9H16.5" 
      stroke="currentColor" 
      strokeWidth="2" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path 
      opacity="0.3" 
      d="M12.1797 12.1797L14.3022 14.3022" 
      stroke="currentColor" 
      strokeWidth="2" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path 
      d="M9 13.5V16.5" 
      stroke="currentColor" 
      strokeWidth="2" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
  </svg>
);

export default ThinkingIcon;
